import vest, { enforce, test } from 'vest/vest.js';

export const formValidation = vest.create((data = {}) => {
  const { consent_signed } = data;

  test('consent_signed', 'error_message_privacy_policy_consent', () => {
    enforce(consent_signed).isTruthy();
  });
});
